import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, InputTipo, IInputTipoLng, ModelNumStr } from '../../models/-index';

@Injectable()
export class InputTipoService extends CrudGenericsService<InputTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/InputTipo`);
    this.base = `${env.apiUrl}/api/InputTipo/`;
  }

  GetInputTipo_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'GetInputTipo_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // web
  GetAll_InputTipoLng(): Observable<IInputTipoLng[]> {
    const url = this.base + 'GetAll_InputTipoLng';
    return this.http.get<IInputTipoLng[]>(`${url}`);
  }
}
